import { render } from "./PdfFields.vue?vue&type=template&id=e2636068&scoped=true"
import script from "./PdfFields.vue?vue&type=script&lang=js"
export * from "./PdfFields.vue?vue&type=script&lang=js"

import "./PdfFields.vue?vue&type=style&index=0&id=e2636068&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2636068"]])

export default __exports__